module.exports = __webpack_public_path__ + "static/media/productlist.e8c7e437.png";